module.exports = __webpack_public_path__ + "static/media/tracking.33f95251.svg";